import { render } from "./App.vue?vue&type=template&id=1df923e8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1df923e8&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__